import { createReducer, on, Action } from '@ngrx/store';
import {
  loadSourceCountry,
  loadSourceCountrySuccess,
  loadSourceCountryFailure,
  deleteSourceCountry,
} from './source-country.actions';
import {
  initialSourceCountryState,
  SourceCountryState,
} from './source-country.state';
import { CountryInfo } from '@sharedModule/models/country.model';

export const sourceCountryReducer = createReducer(
  initialSourceCountryState,
  on(loadSourceCountry, state => ({ ...state, isLoading: true })),
  on(loadSourceCountrySuccess, (state, { sourceCountries }) => ({
    ...state,
    data: sourceCountries,
    isLoading: false,
  })),
  on(loadSourceCountryFailure, (state, { error }) => ({
    ...state,
    error,
    isLoading: false,
  })),
  on(deleteSourceCountry, (state, action): SourceCountryState => {
    return {
      ...state,
      data: state.data?.filter(
        (sourceCountry: CountryInfo) =>
          sourceCountry.countryName !== action.srcCountryName
      ),
    };
  })
);

export function reducer(
  state: SourceCountryState | undefined,
  action: Action
): SourceCountryState {
  return sourceCountryReducer(state, action);
}
